import { Component, computed } from '@angular/core';
import { FindItemComponent, TableCol } from 'ets-fe-ng-sdk';
import { INotificationReceiver } from '../../../../Reusables/reusable-pages/messages/messages.model';
import { MessageService } from '../../../../Reusables/reusable-pages/messages/message.service';

@Component({
  selector: 'notification-history',
  imports: [FindItemComponent],
  templateUrl: './notification-history.component.html',
  styleUrl: './notification-history.component.scss',
})
export class NotificationHistoryComponent {
  readonly columns = computed<TableCol<INotificationReceiver>[]>(() => [
    { f: '_body', t: 'Body' },
    { f: '_title', t: 'Title' },
    { f: 'read', t: 'Read', formatter: this.mS.uS.yesNoCellFormatter },
    { f: 'createdOn', t: 'Sent On', formatter: this.mS.uS.fullDateTime },
  ]);
  constructor(public mS: MessageService) {}
}
